import React from 'react';

export function SourcesProgress({ platform, updating = false }) {
  return <p className="sources-progress" role="status">
    <span className="spinner" aria-hidden="true" />
    {updating ? `Updating ${platform} sources…` : `Loading ${platform} account and campaigns…`}
  </p>;
}

export default function SourcesLoading({ platform }) {
  return <>
    <SourcesProgress platform={platform} />
    <div className="sources-loading" aria-busy="true" aria-label={`Loading ${platform} sources`}>
      <div className="connection-summary loading-summary" aria-hidden="true"><span /><span /><span /></div>
      <div className="card sources-loading-card" aria-hidden="true">
        <span className="loading-line loading-line-short" />
        <span className="loading-line" />
        {[0, 1, 2, 3].map((row) => <div className="sources-loading-row" key={row}>
          <span className="loading-line" /><span className="loading-line" /><span className="loading-button" />
        </div>)}
      </div>
    </div>
  </>;
}
